import { Component, Vue } from 'vue-property-decorator'
import { getTemplateList, createTemplate, setCanUse, getTemplateDetail } from '@/api'
@Component({ name: 'template-manage-page' })
export default class TemplateManagePage extends Vue {
  private createDialogVisible = false // 创建模板是否打开
  private lookDialogVisible1 = false // 短信查看
  private lookDialogVisible2 = false // 邮件查看
  private totalPage = 100;
  private currentPage = 1;
  private tableData = []
  private lookData = {}
  private templateData = {
    templateType: '', // 模版类型
    templateName: '', // 模板名称
    sendTime: '', // 发送阶段
    detail: '', // 发送内容
    subject: '', // 发送主体
    attachment: [], // 附件
    sendType: 2 // 发送方式 1，短信；2，邮件
  }

  private isAutoList = [
    { name: '全部', val: 0 }, { name: '自动', val: 1 }, { name: '非自动', val: 2 }
  ]

  private isAuto = null

  private searchName = null
  created () {
    this.initPageData()
  }

  private async onSearch () {
    this.currentPage = 1
    this.tableData = []
    this.initPageData()
  }

  private async initPageData () {
    const result: any = await getTemplateList({ page: this.currentPage, limit: 20, templateName: this.searchName, isAuto: this.isAuto })
    const { allPage, currentPage, templateList } = result
    this.currentPage = currentPage
    this.totalPage = allPage
    this.tableData = templateList
  }

  private onPageChange () {
    this.initPageData()
  }

  /**
   * [description] 创建模板的按钮被点击
   */
  private onCreateClick () {
    this.createDialogVisible = true
  }

  /**
   * [description] 新建模板的dialog的确定按钮被点击的回调函数
   */
  private async onCreateDialogOkClick () {
    this.createDialogVisible = false
    const id: any = await createTemplate({ templateType: this.templateData.templateType, templateName: this.templateData.templateName, sendTime: this.templateData.sendTime, sendType: this.templateData.sendType })
    if (this.templateData.sendType === 1) {
      this.$router.push({ path: '/message/sms_edit', query: { action: 'edit', id } })
    } else if (this.templateData.sendType === 2) {
      this.$router.push({ path: '/message/email_edit', query: { action: 'edit', id } })
    }
  }

  /**
   * [description] 浏览按钮被点击
   */
  private async onLookClick (data: any) {
    const { sendType, id } = data
    const result: any = await getTemplateDetail({ id: Number(id) })
    if (sendType === 1) {
      this.lookDialogVisible1 = true
    } else if (sendType === 2) {
      this.lookDialogVisible2 = true
    }

    this.lookData = result
  }

  /**
   * [description] 编辑模板被点击
   */
  private onEditClick (item: any) {
    this.$router.push({ path: '/message/email_edit', query: { action: 'edit', id: item.id } })
  }

  // 禁用
  private async onTurnOffClick (item: any) {
    this.$confirm('删除后，原模板将全部清除', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      center: true
    }).then(async () => {
      await setCanUse({ id: item.id, canUse: false })
      this.$message({ message: '操作成功', type: 'success' })
      this.initPageData()
    })
  }

  // 启用
  private async onTurnOnClick (item: any) {
    await setCanUse({ id: item.id, canUse: true })
    this.$message({ message: '操作成功', type: 'success' })
    this.initPageData()
  }
}
